import { render, staticRenderFns } from "./change-log.vue?vue&type=template&id=bf70763e&scoped=true&"
import script from "./change-log.vue?vue&type=script&lang=js&"
export * from "./change-log.vue?vue&type=script&lang=js&"
import style0 from "./change-log.vue?vue&type=style&index=0&id=bf70763e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf70763e",
  null
  
)

export default component.exports